import { createApiSlice } from "@common";
import {
  CRUD_ATTACHMENT,
  CRUD_ATTACHMENT_BY_ID
} from "@routes";

const apiConfig = [
  {
    name: "addAttachment",
    method: "post",
    url: CRUD_ATTACHMENT,
    stateKey: "message",
  },
  {
    name: "getAttachment",
    method: "get",
    url: CRUD_ATTACHMENT_BY_ID,
    stateKey: "data",
  },
  {
    name: "updateAttachment",
    method: "put",
    url: CRUD_ATTACHMENT,
    stateKey: "message",
  },
  {
    name: "deleteAttachment",
    method: "delete",
    url: CRUD_ATTACHMENT,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
    loading: false,
    selectedData: null,
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
    setSelectedData: (state, action) => {
      state.selectedData = action.payload;
    },
  },
};

const { slice, thunks, actions } = createApiSlice(
  "attachment",
  apiConfig,
  customReducers,
);

const attachmentSlice = slice;

export default attachmentSlice.reducer;

export const {
  addAttachment,
  getAttachment,
  updateAttachment,
  deleteAttachment,
} = thunks;

export const { rowSelect, setAdditionalData, setSelectedData } = actions;
